'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isSafeInteger(value) {
    return Number.isSafeInteger(value);
}

exports.isSafeInteger = isSafeInteger;
